import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback } from 'reactstrap';
import logoDark2 from "../../assets/images/logo-dark.png"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from '../../components/Common/ApiManagement/apiServices';
import { handleErrors, showToaster } from "components/Common/common";
import { Link, useNavigate } from "react-router-dom";
import { PAGEPATHS } from "components/Common/Constant";


import * as Yup from "yup";
import { useFormik } from "formik";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();


  const code = location.search.split('?')[1]; 

    const validation = useFormik({
      enableReinitialize: true,
  
      initialValues: {
        newPassword: "",
        confirmPassword: "",
      },
      validationSchema: Yup.object({     
        newPassword: Yup.string().required("Please Enter Your Password"),
        confirmPassword: Yup.string().required("Please Confirm Your Password")
      .oneOf([Yup.ref('newPassword'), null], "Passwords must match"),
      }),
      onSubmit: (values) => {
        handleSubmit(values);
      }
    })
      const handleSubmit = async (values) => {
        const postForm = {        
          password: values.confirmPassword,
          code,
        }
         try {
            const {data} = await axiosInstance.post(ApiNames.USER_RESET, postForm);
            if(data.status === 0){
              showToaster(data.status, data.message)
            }
              if (data.status === 1) {
                      showToaster(data.status, data.message)
                      navigate(PAGEPATHS.Login);
                    }
         } catch (error) {
             handleErrors(error);
         }
      };

 
  return (
    <React.Fragment>
      <div className="account-pages pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">

                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark2} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoDark2} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>

                  <div className="p-3">                 
                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();

                      }}
                    >                    
                      <div className="mb-3">
                        <div className='d-flex justify-content-between'>
                          <Label htmlFor="newpassword">New Password</Label>
                        </div>
                        <Input
                          name="newPassword"
                          value={validation.values.newPassword || ""}
                          className='form-control py-2'
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.newPassword && validation.errors.newPassword ? true : false
                          }
                        />
                        {validation.touched.newPassword && validation.errors.newPassword ? (
                          <FormFeedback type="invalid">{validation.errors.newPassword}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <div className='d-flex justify-content-between'>
                          <Label htmlFor="confirmPassword">Confirm Password</Label>
                        </div>
                        <Input
                          name="confirmPassword"
                          value={validation.values.confirmPassword || ""}
                          className='form-control py-2'
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                          }
                        />
                        {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                          <FormFeedback type="invalid">{validation.errors.confirmPassword}</FormFeedback>
                        ) : null}
                      </div>
                     
                      <div className="col-6 d-flex w-100 align-items-center justify-content-center">
                        <button
                          className="btn text-center py-2 btn-primary w-md waves-effect waves-light"
                          type="submit"
                        >
                          Reset password
                        </button>
                      </div>
                    </Form>
                  </div>              
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
};

export default ResetPassword;
